import { postData, putData } from './core';
import { AuthContextProps } from '../components/auth-context';
import ChangeUserNameForm from '../types/change-username-form';

export default class ChangeCellPhoneApi {
  static uri = 'a/accounts/ChangeCustomerCellPhone';
  context: AuthContextProps;
  constructor(context: AuthContextProps) {
    this.context = context;
  }
  post(data: ChangeUserNameForm) {
    return postData({
      uri: ChangeCellPhoneApi.uri,
      data,
      context: this.context,
    });
  }

  put(data: ChangeUserNameForm) {
    return putData({
      uri: ChangeCellPhoneApi.uri,
      id: '_',
      data,
      context: this.context,
    });
  }
}
